import { ClubLocalModule } from '@modules/application/application';

export const SocialLocalModule: ClubLocalModule = {
    code: 'eee4e0e95c514aae9ea1b8850ace0983',
    localEnabled: true,
    name: 'Social',
    includeInNavigation: false,
};
